module.exports = __webpack_public_path__ + "img/Welcome-Efide-newgirl.a0789091.webp";